export default [
  {
    question: 'What is GradFits?',
    answer:
      'We’re a graduation solution. We’re an environment solution. We’re a budget solution. We are a graduation regalia rental service.',
  },
  // TODO make this multiline within the faq page
  {
    question: 'How does GradFits work?',
    answer: `It’s quite simple.
      You rent your gown online. 
      We ship it to you.
      You wear it at graduation.
      Within three days of graduation you drop it off at your local UPS.
      Then we sanitize the gowns and get them ready for the next round of graduates.`,
  },
  {
    question: 'Do you have gowns for any other departments?',
    answer:
      'We currently only have gowns for the Engineering Department. Our dream would be to expand to other departments as well. If you have a gown from a different department that you’d like to donate, please send us an email! Insert a link here!!',
  },
  {
    question: 'How can I donate my graduation regalia?',
    answer:
      'Great news!!! We’re always looking for a donation, as it means you’re helping another student and you’re helping the Earth. To start the process, just send us an email. From there, we will coordinate an in-person pick up or reimburse you for mailing us your graduation regalia. Insert a link here!!',
  },
  {
    question: 'What if I want to decorate my hat?',
    answer:
      'You are welcome to decorate your cap as long as you do not leave any marks on the cap. You could make your decorations on a square paper and then tape that paper to the cap. Make sure to use masking tape or painter’s tape so you don’t leave any tape residue on the cap. Do not glitter glue your cap or paint or draw on your cap.',
  },
  {
    question: 'Can I rent just single or a few graduation items?',
    answer:
      'Unfortunately, for now, no. We understand that many students are just looking for a stole or a cap, etc. We’re looking to expand our product selection soon.',
  },
  {
    question:
      'What if I want to take pictures with my gown earlier in the semester?',
    answer:
      'No problem at all! Just indicate when you want your gown by in the check-out process. Everything is good as long as you return your gown in good condition within 3 days (postmarked) of your graduation.',
  },
  {
    question: 'What if I damage my gown?',
    answer:
      'No worries if they are just small stains (that can be washed out) or holes/rips under one inch wide. If we can’t get the stain out or sew the regalia up to a good condition, we will have to bill you for the cost of the regalia, unfortunately.',
  },
  {
    question: 'How do I know this payment is secure?',
    answer:
      'The safety of your information is our priority as well. We heavily researched online payment systems. We found that Stripe <https://stripe.com/> was incredibly safe and used by many other companies. For more details regarding the security of Stripe, check out their site <https://stripe.com/docs/security/stripe>.',
  },
  {
    question: 'What is this $49.99 security deposit?',
    answer:
      'We return this security deposit as soon as we receive your gown. If you don’t return your gown to use within a week of your graduation (postmarked), we would keep the $49.99 security deposit. ',
  },
];
